/** @type {import('../help-index.js').HelpSidebarItem} */
export const TAX_IVA_DDJJ_PORTAL_ITEM = {
  id: 'sub_nav_1',
  screenId: 'tax-iva-ddjj-portal',
  label: 'DDJJ — Portal IVA',
  description: 'Exportar archivos para el Portal IVA de AFIP.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Generás los archivos de libro IVA ventas y compras en formato que pide el Portal IVA de AFIP, para un mes o rango de fechas.',
      },
      {
        title: 'Paso 1 — Elegir período',
        bullets: [
          'Atajos de meses recientes (ej. «Enero 26») o fechas Desde / Hasta manuales.',
        ],
      },
      {
        title: 'Paso 2 — Descargar',
        bullets: [
          'Botones para exportar libro de ventas y/o compras según lo que necesites subir al portal.',
          'El archivo se descarga en tu equipo para cargarlo en AFIP.',
        ],
      },
    ],
  },
}
